import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@els/els-react--loader';
import TreeView from '@Containers/TreeView';

const spinnerId = 'datapoints-spinner';

function DatapointsExportModalContent({ isLoading, getDatapoints, changeDatapoints, selectedDatapoints }) {
  return (
    <div className="exportModal__content">
      {isLoading && <Loader id={spinnerId} isVisible isBlocking={false} isSmall />}
      <TreeView
        taxonomyType="export"
        taxonomiesGetter={getDatapoints}
        selectedItems={selectedDatapoints.ids}
        onChange={changeDatapoints}
        showCountIndicator={false}
        selectedCustomItems={[]}
        layout="sidebar"
        ariaLabel="Export datapoints tree"
      />
    </div>
  );
}

DatapointsExportModalContent.propTypes = {
  isLoading: PropTypes.bool,
  selectedDatapoints: PropTypes.object,
  getDatapoints: PropTypes.func.isRequired,
  changeDatapoints: PropTypes.func.isRequired,
};

export default DatapointsExportModalContent;
